import React from 'react';
import { freshnessBadge } from '../utils/processorFreshness';
import {
  processorAddressDisplay,
  processorDirectionsUrl,
  processorPhoneDisplay,
  processorSourceLabel,
  processorTelHref,
} from '../utils/processorList';
import './ProcessorDetailPanel.css';

export function ProcessorDetailPanel({ row, onClose, onCompleteListing }) {
  if (!row) return null;

  const badge = freshnessBadge(row.freshness);
  const miles = Number.isFinite(row.miles) ? row.miles.toFixed(1) : '—';
  const drive = Number.isFinite(row.drive_minutes) ? `${row.drive_minutes}` : '—';
  const phone = processorPhoneDisplay(row.phone);
  const hasPhone = Boolean(String(row.phone || '').trim());
  const services = Array.isArray(row.services) ? row.services.filter(Boolean) : [];
  const notes = String(row.notes || '').trim();
  const canClaim = row.source === 'place';

  return (
    <div className="pdp" data-testid="processor-detail-panel">
      <button type="button" className="pdp__backdrop" aria-label="Close" onClick={onClose} />
      <aside className="pdp__sheet" role="dialog" aria-modal="true" aria-labelledby="pdp-name">
        <div className="pdp__header">
          <span className="pdp__source">{processorSourceLabel(row)}</span>
          <button type="button" className="pdp__close" onClick={onClose}>
            CLOSE
          </button>
        </div>

        <div className="pdp__body">
          <div>
            <h2 id="pdp-name" className="pdp__name">{row.name}</h2>
            <div className="pdp__meta">
              {row.town || '—'}
              {' · '}
              {miles}
              {' MI · '}
              {drive}
              {' DRIVE'}
            </div>
            <div className="pdp__chips">
              <span className={`fap-badge fap-badge--${badge.tone}`}>{badge.label}</span>
            </div>
          </div>

          <div className="pdp__actions">
            <a
              className="pdp__call"
              href={hasPhone ? processorTelHref(row.phone) : undefined}
              aria-disabled={!hasPhone}
              data-testid="pdp-call"
            >
              CALL AHEAD
            </a>
            <a
              className="pdp__dir"
              href={processorDirectionsUrl(row)}
              target="_blank"
              rel="noreferrer"
              data-testid="pdp-directions"
            >
              DIRECTIONS
            </a>
          </div>

          <div className="pdp__card">
            <div className="pdp__kicker">Contact</div>
            <div className="pdp__phone">{phone}</div>
            <div className="pdp__addr">{processorAddressDisplay(row)}</div>
          </div>

          {services.length > 0 ? (
            <div>
              <div className="pdp__kicker pdp__kicker--block">Services</div>
              <div className="pdp__svc">
                {services.map((service) => (
                  <span key={service} className="pdp__svc-chip">{service}</span>
                ))}
              </div>
            </div>
          ) : null}

          {notes ? <div className="pdp__notes">{notes}</div> : null}

          {canClaim ? (
            <div className="pdp__claim">
              <button
                type="button"
                className="pdp__claim-btn"
                onClick={() => onCompleteListing?.(row)}
              >
                COMPLETE THIS LISTING
              </button>
            </div>
          ) : null}
        </div>
      </aside>
    </div>
  );
}
